import { ActionContext } from 'vuex';
import { get, post, ApiResult, checkResult } from '../helpers/api';
import { State } from './abstractions';
import { PlantInfo, User } from '../model';

type RegisterResult = ApiResult<void>;
type AuthenticationResult = ApiResult<{user?: User, next?: string}>;
type UserPlantsResult = ApiResult<{plantsInfo?: PlantInfo[], next?: string}>;

async function register(ctx: ActionContext<State,any>, data: any) {
    const endpoint = `/_api/v1/auth/register`;

    let result: RegisterResult = await post(endpoint, data).then(res => res.data);

    return result;
}

async function signIn(ctx: ActionContext<State,any>, data: any) {
    const endpoint = `/_api/v1/auth/signin`;

    let res = await post(endpoint, data).then(res => res.data) as AuthenticationResult;
    if (res && res.result == 'OK') {
        return res.data;
    }
}

async function signInOidc(ctx: ActionContext<State,any>, data: any) {
    const endpoint = `/_api/v1/auth/signin-oidc`;

    let res = await post(endpoint, data).then(res => res.data) as AuthenticationResult;
    if (res && res.result == 'OK') {
        return res.data;
    }
}

async function consentInfo(ctx: ActionContext<State,any>, data: any) {
    const endpoint = `/_api/v1/auth/consent`;

    let result: AuthenticationResult = await get(endpoint, data).then(res => res.data);

    return result;
}

async function consent(ctx: ActionContext<State,any>, data: any) {
    const endpoint = `/_api/v1/auth/consent`;

    let result: AuthenticationResult = await post(endpoint, data).then(res => res.data);

    return result;
}

async function signOut(ctx: ActionContext<State,any>) {
    const endpoint = `/_api/v1/auth/logout`;

    let result: AuthenticationResult = await post(endpoint).then(res => res.data);

    ctx.commit('updateAuthentication', { result: result.result, user: null });

    return result;
}

function passwordSendUpdateEmail(ctx: ActionContext<State,any>, data: any) {
    const endpoint = `/_api/v1/auth/password/send-update-email`;

    return post(endpoint, data).then(res => res.data);
}

function passwordUpdate(ctx: ActionContext<State,any>, data: any) {
    const endpoint = `/_api/v1/auth/password/update`;

    return post(endpoint, data).then(res => res.data);
}

function emailSendConfirmEmail(ctx: ActionContext<State,any>, data: any) {
    const endpoint = `/_api/v1/auth/email/send-confirm-email`;

    return post(endpoint, data).then(res => res.data);
}

function emailConfirm(ctx: ActionContext<State,any>, data: any) {
    const endpoint = `/_api/v1/auth/email/confirm`;

    return post(endpoint, data).then(res => res.data);
}

async function signInWithToken(ctx: ActionContext<any,any>, data: any) {
    const endpoint = `/_api/v1/auth/sign-in-with-token`;

    let result: AuthenticationResult = await post(endpoint, data, data.token)
        .then(res => res.data);
    
    return checkResult(result);
}

async function authenticationCheck(ctx: ActionContext<any,any>, data: any) {
    const endpoint = `/_api/v1/auth/check`;

    if (!ctx.state.isAuthenticated) {
        let result: AuthenticationResult = await get(endpoint)
            .then(res => res.data);

        ctx.commit('updateAuthentication', { result: result.result, user: result.data && result.data.user });

        return checkResult(result);
    }
    else {
        return true;
    }
}

async function getUserPlants(ctx: ActionContext<any,any>, data: any) {
    const endpoint = `/_api/v1/auth/user-plants`;

    let result: UserPlantsResult = await get(endpoint, null)
        .then(res => res.data);

    ctx.commit('updateUserPlants', { result: result.result, plantsInfo: result.data && result.data.plantsInfo });

    return result;
}

async function deleteUser(ctx: ActionContext<any,any>, data: any) {
    const endpoint = `/_api/v1/auth/delete-user`;

    console.log("DELETE DATA", data);

    let result: AuthenticationResult = await post(endpoint, data)
        .then(res => res.data);

    return result;
}

export const actions = {
    register,
    signIn,
    signInOidc,
    signOut,
    authenticationCheck,
    passwordSendUpdateEmail,
    passwordUpdate,
    emailSendConfirmEmail,
    emailConfirm,
    consentInfo,
    consent,
    getUserPlants,
    signInWithToken,
    deleteUser,
}